import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Copy } from "lucide-react";
import { api, imgUrl } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;
const stem = (n) => n.replace(/\.[^.]+$/, "");

export const ClientFavorites = ({ item }) => {
  const [files, setFiles] = useState(null);
  const key = (item.favorites || []).join("|");
  useEffect(() => {
    if (!item.id || !key) { setFiles([]); return; }
    api.get(`/admin/client-galleries/${item.id}/favorites`).then((r) => setFiles(r.data)).catch(() => setFiles([]));
  }, [item.id, key]);
  if (!files) return <p className="text-sm text-slate-500">Caricamento...</p>;
  if (!files.length) return <p className="text-sm text-slate-500" data-testid="client-favorites-empty">Nessuna foto selezionata dal cliente.</p>;
  const copy = () => { navigator.clipboard?.writeText(files.map((f) => stem(f.filename)).join(", ")); toast.success("Nomi copiati: incollali nel filtro \"Nome file\" del tuo programma"); };
  return (
    <div className="space-y-3" data-testid="client-favorites">
      <div className="flex flex-wrap gap-2">
        <a href={`${BASE}/api/admin/client-galleries/${item.id}/favorites.zip`} className="inline-flex items-center gap-2 bg-slate-900 text-white text-sm px-4 py-2 rounded-md" data-testid="client-favorites-download"><Download size={15} /> Scarica le {files.length} preferite (ZIP)</a>
        <button type="button" onClick={copy} className="inline-flex items-center gap-2 border border-slate-300 text-sm px-4 py-2 rounded-md hover:bg-slate-50" data-testid="client-favorites-copy"><Copy size={15} /> Copia i nomi dei file</button>
      </div>
      <ul className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="client-favorites-list">{files.map((f) => (
        <li key={f.url} className="flex items-center gap-2 border border-slate-200 rounded-md p-1.5 bg-white">
          <img src={imgUrl(f.url)} alt="" className="w-10 h-10 object-cover rounded" loading="lazy" />
          <span className="text-xs font-mono text-slate-700 break-all">{f.filename}</span>
        </li>))}</ul>
    </div>
  );
};
